var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.arquivo)?_c('div',{staticClass:"download"},[_c('ed-button',{attrs:{"iconLeft":_vm.$utilidade.getIcone('download'),"label":'Arquivo ' +
      _vm.arquivo.strNome +
      '(' +
      _vm.$utilidade.toMb(_vm.arquivo.intTamanho) +
      ')',"text":""},on:{"click":_vm.download}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }